<template>
  <div class="card modal-card is-min-width-800 width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('detailClient.popupGenerateMandat.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                      :error="error"
                      :messagesChampsVide="messagesChampsVide"
                      :champsVide="champsVide"
                      :title="'editionClient.problemOccurred'"
                      :withEmplyFields="true"
                      @close="error = $event"/>
        <div class="columns is-multiline mgt-20px">
          <b-field :label="$t('detailClient.popupGenerateMandat.typeMandatSepa')"
              class="column is-12 obligatoire">
            <b-select
              v-model="typeMandatSepa"
              expanded
              @input="updateEcraserRum">
              <option
                  v-for="type in LISTE_TYPE_MANDAT"
                  :key="type.code"
                  :value="type.code">
                    {{$t(type.libelle)}}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t('detailClient.popupGenerateMandat.dateMandat')"
                  class="column is-6 obligatoire">
            <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          position="is-bottom-right"
                          v-model="dateMandat"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('detailClient.popupGenerateMandat.banque')"
              class="column is-6 obligatoire">
            <b-select v-model="domiciliationBancaireId" expanded>
              <option v-for="domiciliation in domiciliationBancaireAvecIcs"
                      :value="domiciliation.id" :key="domiciliation.id">
                {{ `${domiciliation.libelle} - ${domiciliation.libelleBanque}` }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="columns mgt-10px is-multiline "
          v-if="tiers.referenceUniqueMandat != null">
          <div class="column is-narrow">
            {{$t('detailClient.popupGenerateMandat.rumActual')}}
          </div>
          <div class="column has-text-default has-text-weight-semibold">
            {{tiers.referenceUniqueMandat}}
          </div>
          <div class="column is-narrow">
            {{$t('detailClient.popupGenerateMandat.rum')}}
          </div>
          <div class="column">
            <qd-switch  v-model="ecraserRum" :disabled="isTypeChanged"></qd-switch>
          </div>
        </div>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="appliquer()">
                {{ $t('general.button.appliquer') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { generateMandat } from '@/api/tiers/index';
import formatDate from '@/services/general/formatIsoDate';
import messageSuccess from '@/services/general/messageSucces';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import validation from '@/services/validation/validation';
import translate from '@/services/tiers/champsTiersTranslator';
import validationTiers from '@/services/tiers/validationTiers';
import { LISTE_TYPE_MANDAT } from '@/configuration/tiers/tiersConf';
import moment from 'moment';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popupGenerateMandat',
  components: {
    errorMsgComponent,
  },
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      dateMandat: new Date(),
      domiciliationBancaireId: null,
      ecraserRum: false,
      typeMandatSepa: LISTE_TYPE_MANDAT[0].code,
      LISTE_TYPE_MANDAT,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    domiciliationBancaireAvecIcs() {
      const domBancaires = this.parametre(
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ).filter((domicialisation) => {
        return domicialisation.actif && domicialisation.ribSepaId;
      });
      return domBancaires;
    },
    isTypeChanged() {
      return this.typeMandatSepa !== this.tiers.typeMandatSepa;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateEcraserRum() {
      this.ecraserRum = this.isTypeChanged;
    },
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];

        const dto = {
          tiersId: this.tiers.id,
          dateMandat: formatDate(this.dateMandat),
          domiciliationBancaireId: this.domiciliationBancaireId,
          ecraserRum: this.ecraserRum,
          typeMandatSepa: this.typeMandatSepa,
        };
        await generateMandat(dto);

        loadingComponent.close();
        messageSuccess(this.$i18n.t('detailClient.popupGenerateMandat.success'));
        this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationTiers(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.tiers.dateSignatureMandatSepa !== undefined
        && this.tiers.dateSignatureMandatSepa !== null) {
        this.dateMandat = moment(this.tiers.dateSignatureMandatSepa).toDate();
      }
      if (this.tiers.typeMandatSepa) {
        this.typeMandatSepa = this.tiers.typeMandatSepa;
      }
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ]);
      if (this.domiciliationBancaireAvecIcs.length > 0) {
        this.domiciliationBancaireId = this.domiciliationBancaireAvecIcs[0].id;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
